module.exports = __webpack_public_path__ + "img/holzflaechen.8d3bc16.png";